<template>
  <div>
    <div class="page-content">
      <section
        v-for="key in groupedProgramKeys"
        :key="key"
        class="pb-4"
      >
        <p><strong>{{ key }}</strong></p>
        <ProgramsTable :programs="groupedPrograms[key]"/>
      </section>
      <div v-if="!groupedProgramKeys.length">
        <span>No Program Found</span>
      </div>
    </div>
  </div>
</template>

<script>
import _groupBy from 'lodash/groupBy'
import { getShortDescription } from '@/utils/generalUtils'
import ProgramsTable from '@/themes/cuny/ProgramsTable'
const groupProgramsBy = 'type'

export default {
  components: {
    ProgramsTable,
  },
  props: {
    programs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    groupedPrograms() {
      return _groupBy(
        this.programs.map((p) => (p.type ? p : { ...p, type: '' })),
        groupProgramsBy
      )
    },
    groupedProgramKeys() {
      return Object.keys(this.groupedPrograms).sort()
    },
  },
  methods: {
    getShortDescription,
    getDirector(contacts) {
      const director = contacts.find((contact) => contact.type === 'director')
      return director ? director.name : ''
    },
  },
}
</script>
